(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'automated-workflows-shared'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'automated-workflows-shared'.");
    }
    root['automated-workflows-shared'] = factory(typeof this['automated-workflows-shared'] === 'undefined' ? {} : this['automated-workflows-shared'], kotlin);
  }
}(this, function (_, Kotlin) {
  'use strict';
  var equals = Kotlin.equals;
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var Enum = Kotlin.kotlin.Enum;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var throwISE = Kotlin.throwISE;
  var NoSuchElementException_init = Kotlin.kotlin.NoSuchElementException;
  var setOf = Kotlin.kotlin.collections.setOf_i5x0yv$;
  var emptySet = Kotlin.kotlin.collections.emptySet_287e2$;
  var toMutableSet = Kotlin.kotlin.collections.toMutableSet_7wnvza$;
  var startsWith = Kotlin.kotlin.text.startsWith_7epoxm$;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_287e2$;
  var toSet = Kotlin.kotlin.collections.toSet_7wnvza$;
  var hashCode = Kotlin.hashCode;
  var toString = Kotlin.toString;
  var LinkedHashSet_init = Kotlin.kotlin.collections.LinkedHashSet_init_287e2$;
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  var ArrayList_init_0 = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  var RuntimeException_init = Kotlin.kotlin.RuntimeException_init_pdl1vj$;
  var RuntimeException = Kotlin.kotlin.RuntimeException;
  var copyToArray = Kotlin.kotlin.collections.copyToArray;
  var get_js = Kotlin.kotlin.js.get_js_1yb8b7$;
  var throwCCE = Kotlin.throwCCE;
  var ensureNotNull = Kotlin.ensureNotNull;
  var LinkedHashMap_init = Kotlin.kotlin.collections.LinkedHashMap_init_q3lmfv$;
  EventType.prototype = Object.create(Enum.prototype);
  EventType.prototype.constructor = EventType;
  NodeException.prototype = Object.create(RuntimeException.prototype);
  NodeException.prototype.constructor = NodeException;
  InvalidTargetException.prototype = Object.create(NodeException.prototype);
  InvalidTargetException.prototype.constructor = InvalidTargetException;
  InvalidEventException.prototype = Object.create(NodeException.prototype);
  InvalidEventException.prototype.constructor = InvalidEventException;
  InvalidRootException.prototype = Object.create(NodeException.prototype);
  InvalidRootException.prototype.constructor = InvalidRootException;
  NodeType.prototype = Object.create(Enum.prototype);
  NodeType.prototype.constructor = NodeType;
  function EventType(name, ordinal, value) {
    Enum.call(this);
    this.value = value;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function EventType_initFields() {
    EventType_initFields = function () {
    };
    EventType$POTENTIAL_INCIDENT_instance = new EventType('POTENTIAL_INCIDENT', 0, potentialIncidentPrefix);
    EventType$SENDER_POLICY_CREATED_instance = new EventType('SENDER_POLICY_CREATED', 1, senderPolicyPrefix);
    EventType$USER_REPORTED_instance = new EventType('USER_REPORTED', 2, userReportedPrefix);
    EventType$POTENTIAL_INCIDENT_EMAILS_DETECTED_COUNT_instance = new EventType('POTENTIAL_INCIDENT_EMAILS_DETECTED_COUNT', 3, 'potentialIncidentEmailsDetectedCount');
    EventType$POTENTIAL_INCIDENT_IS_EXTERNAL_instance = new EventType('POTENTIAL_INCIDENT_IS_EXTERNAL', 4, 'potentialIncidentIsExternal_noInput');
    EventType$POTENTIAL_INCIDENT_IS_INTERNAL_instance = new EventType('POTENTIAL_INCIDENT_IS_INTERNAL', 5, 'potentialIncidentIsInternal_noInput');
    EventType$POTENTIAL_INCIDENT_IS_TYPE_POST_DELIVERY_instance = new EventType('POTENTIAL_INCIDENT_IS_TYPE_POST_DELIVERY', 6, 'potentialIncidentIsTypePostDelivery_noInput');
    EventType$POTENTIAL_INCIDENT_IS_TYPE_RELATED_instance = new EventType('POTENTIAL_INCIDENT_IS_TYPE_RELATED', 7, 'potentialIncidentIsTypeRelated_noInput');
    EventType$POTENTIAL_INCIDENT_MAILBOXES_AFFECTED_COUNT_instance = new EventType('POTENTIAL_INCIDENT_MAILBOXES_AFFECTED_COUNT', 8, 'potentialIncidentMailboxesAffectedCount');
    EventType$POTENTIAL_INCIDENT_SENDER_COUNTRY_instance = new EventType('POTENTIAL_INCIDENT_SENDER_COUNTRY', 9, 'potentialIncidentSenderCountry');
    EventType$POTENTIAL_INCIDENT_SENDER_EMAIL_instance = new EventType('POTENTIAL_INCIDENT_SENDER_EMAIL', 10, 'potentialIncidentSenderEmail');
    EventType$POTENTIAL_INCIDENT_SUBJECT_instance = new EventType('POTENTIAL_INCIDENT_SUBJECT', 11, 'potentialIncidentSubject');
    EventType$SENDER_POLICY_BLOCK_instance = new EventType('SENDER_POLICY_BLOCK', 12, 'senderPolicyBlock_noInput');
    EventType$SENDER_POLICY_QUARANTINE_instance = new EventType('SENDER_POLICY_QUARANTINE', 13, 'senderPolicyQuarantine_noInput');
    EventType$SENDER_POLICY_CREATED_BY_instance = new EventType('SENDER_POLICY_CREATED_BY', 14, 'senderPolicyBy');
    EventType$SENDER_POLICY_EMAILS_DETECTED_COUNT_instance = new EventType('SENDER_POLICY_EMAILS_DETECTED_COUNT', 15, 'senderPolicyEmailsDetectedCount');
    EventType$SENDER_POLICY_MAILBOXES_AFFECTED_COUNT_instance = new EventType('SENDER_POLICY_MAILBOXES_AFFECTED_COUNT', 16, 'senderPolicyMailboxesAffectedCount');
    EventType$SENDER_POLICY_SENDER_COUNTRY_instance = new EventType('SENDER_POLICY_SENDER_COUNTRY', 17, 'senderPolicySenderCountry');
    EventType$USER_REPORTED_IS_EXTERNAL_instance = new EventType('USER_REPORTED_IS_EXTERNAL', 18, 'userReportedIsExternal_noInput');
    EventType$USER_REPORTED_IS_INTERNAL_instance = new EventType('USER_REPORTED_IS_INTERNAL', 19, 'userReportedIsInternal_noInput');
    EventType$USER_REPORTED_MATCHED_EMAIL_COUNT_instance = new EventType('USER_REPORTED_MATCHED_EMAIL_COUNT', 20, 'userReportedMatchedEmailCount');
    EventType$USER_REPORTED_REPORTED_BY_instance = new EventType('USER_REPORTED_REPORTED_BY', 21, 'userReportedBy');
    EventType$USER_REPORTED_REPORTED_EMAIL_COUNT_instance = new EventType('USER_REPORTED_REPORTED_EMAIL_COUNT', 22, 'userReportedReportedEmailCount');
    EventType$USER_REPORTED_SENDER_COUNTRY_instance = new EventType('USER_REPORTED_SENDER_COUNTRY', 23, 'userReportedSenderCountry');
    EventType$USER_REPORTED_SENDER_EMAIL_instance = new EventType('USER_REPORTED_SENDER_EMAIL', 24, 'userReportedSenderEmail');
    EventType$USER_REPORTED_SUBJECT_instance = new EventType('USER_REPORTED_SUBJECT', 25, 'userReportedSubject');
    EventType$CREATE_INCIDENT_instance = new EventType('CREATE_INCIDENT', 26, 'createIncident');
    EventType$EMAIL_NOTIFICATION_instance = new EventType('EMAIL_NOTIFICATION', 27, 'emailNotification');
    EventType$SLACK_NOTIFICATION_instance = new EventType('SLACK_NOTIFICATION', 28, 'slackNotification');
    EventType$MSTEAMS_NOTIFICATION_instance = new EventType('MSTEAMS_NOTIFICATION', 29, 'msteamsNotification');
    EventType$Companion_getInstance();
  }
  var EventType$POTENTIAL_INCIDENT_instance;
  function EventType$POTENTIAL_INCIDENT_getInstance() {
    EventType_initFields();
    return EventType$POTENTIAL_INCIDENT_instance;
  }
  var EventType$SENDER_POLICY_CREATED_instance;
  function EventType$SENDER_POLICY_CREATED_getInstance() {
    EventType_initFields();
    return EventType$SENDER_POLICY_CREATED_instance;
  }
  var EventType$USER_REPORTED_instance;
  function EventType$USER_REPORTED_getInstance() {
    EventType_initFields();
    return EventType$USER_REPORTED_instance;
  }
  var EventType$POTENTIAL_INCIDENT_EMAILS_DETECTED_COUNT_instance;
  function EventType$POTENTIAL_INCIDENT_EMAILS_DETECTED_COUNT_getInstance() {
    EventType_initFields();
    return EventType$POTENTIAL_INCIDENT_EMAILS_DETECTED_COUNT_instance;
  }
  var EventType$POTENTIAL_INCIDENT_IS_EXTERNAL_instance;
  function EventType$POTENTIAL_INCIDENT_IS_EXTERNAL_getInstance() {
    EventType_initFields();
    return EventType$POTENTIAL_INCIDENT_IS_EXTERNAL_instance;
  }
  var EventType$POTENTIAL_INCIDENT_IS_INTERNAL_instance;
  function EventType$POTENTIAL_INCIDENT_IS_INTERNAL_getInstance() {
    EventType_initFields();
    return EventType$POTENTIAL_INCIDENT_IS_INTERNAL_instance;
  }
  var EventType$POTENTIAL_INCIDENT_IS_TYPE_POST_DELIVERY_instance;
  function EventType$POTENTIAL_INCIDENT_IS_TYPE_POST_DELIVERY_getInstance() {
    EventType_initFields();
    return EventType$POTENTIAL_INCIDENT_IS_TYPE_POST_DELIVERY_instance;
  }
  var EventType$POTENTIAL_INCIDENT_IS_TYPE_RELATED_instance;
  function EventType$POTENTIAL_INCIDENT_IS_TYPE_RELATED_getInstance() {
    EventType_initFields();
    return EventType$POTENTIAL_INCIDENT_IS_TYPE_RELATED_instance;
  }
  var EventType$POTENTIAL_INCIDENT_MAILBOXES_AFFECTED_COUNT_instance;
  function EventType$POTENTIAL_INCIDENT_MAILBOXES_AFFECTED_COUNT_getInstance() {
    EventType_initFields();
    return EventType$POTENTIAL_INCIDENT_MAILBOXES_AFFECTED_COUNT_instance;
  }
  var EventType$POTENTIAL_INCIDENT_SENDER_COUNTRY_instance;
  function EventType$POTENTIAL_INCIDENT_SENDER_COUNTRY_getInstance() {
    EventType_initFields();
    return EventType$POTENTIAL_INCIDENT_SENDER_COUNTRY_instance;
  }
  var EventType$POTENTIAL_INCIDENT_SENDER_EMAIL_instance;
  function EventType$POTENTIAL_INCIDENT_SENDER_EMAIL_getInstance() {
    EventType_initFields();
    return EventType$POTENTIAL_INCIDENT_SENDER_EMAIL_instance;
  }
  var EventType$POTENTIAL_INCIDENT_SUBJECT_instance;
  function EventType$POTENTIAL_INCIDENT_SUBJECT_getInstance() {
    EventType_initFields();
    return EventType$POTENTIAL_INCIDENT_SUBJECT_instance;
  }
  var EventType$SENDER_POLICY_BLOCK_instance;
  function EventType$SENDER_POLICY_BLOCK_getInstance() {
    EventType_initFields();
    return EventType$SENDER_POLICY_BLOCK_instance;
  }
  var EventType$SENDER_POLICY_QUARANTINE_instance;
  function EventType$SENDER_POLICY_QUARANTINE_getInstance() {
    EventType_initFields();
    return EventType$SENDER_POLICY_QUARANTINE_instance;
  }
  var EventType$SENDER_POLICY_CREATED_BY_instance;
  function EventType$SENDER_POLICY_CREATED_BY_getInstance() {
    EventType_initFields();
    return EventType$SENDER_POLICY_CREATED_BY_instance;
  }
  var EventType$SENDER_POLICY_EMAILS_DETECTED_COUNT_instance;
  function EventType$SENDER_POLICY_EMAILS_DETECTED_COUNT_getInstance() {
    EventType_initFields();
    return EventType$SENDER_POLICY_EMAILS_DETECTED_COUNT_instance;
  }
  var EventType$SENDER_POLICY_MAILBOXES_AFFECTED_COUNT_instance;
  function EventType$SENDER_POLICY_MAILBOXES_AFFECTED_COUNT_getInstance() {
    EventType_initFields();
    return EventType$SENDER_POLICY_MAILBOXES_AFFECTED_COUNT_instance;
  }
  var EventType$SENDER_POLICY_SENDER_COUNTRY_instance;
  function EventType$SENDER_POLICY_SENDER_COUNTRY_getInstance() {
    EventType_initFields();
    return EventType$SENDER_POLICY_SENDER_COUNTRY_instance;
  }
  var EventType$USER_REPORTED_IS_EXTERNAL_instance;
  function EventType$USER_REPORTED_IS_EXTERNAL_getInstance() {
    EventType_initFields();
    return EventType$USER_REPORTED_IS_EXTERNAL_instance;
  }
  var EventType$USER_REPORTED_IS_INTERNAL_instance;
  function EventType$USER_REPORTED_IS_INTERNAL_getInstance() {
    EventType_initFields();
    return EventType$USER_REPORTED_IS_INTERNAL_instance;
  }
  var EventType$USER_REPORTED_MATCHED_EMAIL_COUNT_instance;
  function EventType$USER_REPORTED_MATCHED_EMAIL_COUNT_getInstance() {
    EventType_initFields();
    return EventType$USER_REPORTED_MATCHED_EMAIL_COUNT_instance;
  }
  var EventType$USER_REPORTED_REPORTED_BY_instance;
  function EventType$USER_REPORTED_REPORTED_BY_getInstance() {
    EventType_initFields();
    return EventType$USER_REPORTED_REPORTED_BY_instance;
  }
  var EventType$USER_REPORTED_REPORTED_EMAIL_COUNT_instance;
  function EventType$USER_REPORTED_REPORTED_EMAIL_COUNT_getInstance() {
    EventType_initFields();
    return EventType$USER_REPORTED_REPORTED_EMAIL_COUNT_instance;
  }
  var EventType$USER_REPORTED_SENDER_COUNTRY_instance;
  function EventType$USER_REPORTED_SENDER_COUNTRY_getInstance() {
    EventType_initFields();
    return EventType$USER_REPORTED_SENDER_COUNTRY_instance;
  }
  var EventType$USER_REPORTED_SENDER_EMAIL_instance;
  function EventType$USER_REPORTED_SENDER_EMAIL_getInstance() {
    EventType_initFields();
    return EventType$USER_REPORTED_SENDER_EMAIL_instance;
  }
  var EventType$USER_REPORTED_SUBJECT_instance;
  function EventType$USER_REPORTED_SUBJECT_getInstance() {
    EventType_initFields();
    return EventType$USER_REPORTED_SUBJECT_instance;
  }
  var EventType$CREATE_INCIDENT_instance;
  function EventType$CREATE_INCIDENT_getInstance() {
    EventType_initFields();
    return EventType$CREATE_INCIDENT_instance;
  }
  var EventType$EMAIL_NOTIFICATION_instance;
  function EventType$EMAIL_NOTIFICATION_getInstance() {
    EventType_initFields();
    return EventType$EMAIL_NOTIFICATION_instance;
  }
  var EventType$SLACK_NOTIFICATION_instance;
  function EventType$SLACK_NOTIFICATION_getInstance() {
    EventType_initFields();
    return EventType$SLACK_NOTIFICATION_instance;
  }
  var EventType$MSTEAMS_NOTIFICATION_instance;
  function EventType$MSTEAMS_NOTIFICATION_getInstance() {
    EventType_initFields();
    return EventType$MSTEAMS_NOTIFICATION_instance;
  }
  function EventType$Companion() {
    EventType$Companion_instance = this;
  }
  EventType$Companion.prototype.from_61zpoe$ = function (value) {
    var $receiver = EventType$values();
    var first$result;
    first$break: do {
      var tmp$;
      for (tmp$ = 0; tmp$ !== $receiver.length; ++tmp$) {
        var element = $receiver[tmp$];
        if (equals(element.value, value)) {
          first$result = element;
          break first$break;
        }
      }
      throw new NoSuchElementException_init('Array contains no element matching the predicate.');
    }
     while (false);
    return first$result;
  };
  EventType$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var EventType$Companion_instance = null;
  function EventType$Companion_getInstance() {
    EventType_initFields();
    if (EventType$Companion_instance === null) {
      new EventType$Companion();
    }
    return EventType$Companion_instance;
  }
  EventType.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'EventType',
    interfaces: [Enum]
  };
  function EventType$values() {
    return [EventType$POTENTIAL_INCIDENT_getInstance(), EventType$SENDER_POLICY_CREATED_getInstance(), EventType$USER_REPORTED_getInstance(), EventType$POTENTIAL_INCIDENT_EMAILS_DETECTED_COUNT_getInstance(), EventType$POTENTIAL_INCIDENT_IS_EXTERNAL_getInstance(), EventType$POTENTIAL_INCIDENT_IS_INTERNAL_getInstance(), EventType$POTENTIAL_INCIDENT_IS_TYPE_POST_DELIVERY_getInstance(), EventType$POTENTIAL_INCIDENT_IS_TYPE_RELATED_getInstance(), EventType$POTENTIAL_INCIDENT_MAILBOXES_AFFECTED_COUNT_getInstance(), EventType$POTENTIAL_INCIDENT_SENDER_COUNTRY_getInstance(), EventType$POTENTIAL_INCIDENT_SENDER_EMAIL_getInstance(), EventType$POTENTIAL_INCIDENT_SUBJECT_getInstance(), EventType$SENDER_POLICY_BLOCK_getInstance(), EventType$SENDER_POLICY_QUARANTINE_getInstance(), EventType$SENDER_POLICY_CREATED_BY_getInstance(), EventType$SENDER_POLICY_EMAILS_DETECTED_COUNT_getInstance(), EventType$SENDER_POLICY_MAILBOXES_AFFECTED_COUNT_getInstance(), EventType$SENDER_POLICY_SENDER_COUNTRY_getInstance(), EventType$USER_REPORTED_IS_EXTERNAL_getInstance(), EventType$USER_REPORTED_IS_INTERNAL_getInstance(), EventType$USER_REPORTED_MATCHED_EMAIL_COUNT_getInstance(), EventType$USER_REPORTED_REPORTED_BY_getInstance(), EventType$USER_REPORTED_REPORTED_EMAIL_COUNT_getInstance(), EventType$USER_REPORTED_SENDER_COUNTRY_getInstance(), EventType$USER_REPORTED_SENDER_EMAIL_getInstance(), EventType$USER_REPORTED_SUBJECT_getInstance(), EventType$CREATE_INCIDENT_getInstance(), EventType$EMAIL_NOTIFICATION_getInstance(), EventType$SLACK_NOTIFICATION_getInstance(), EventType$MSTEAMS_NOTIFICATION_getInstance()];
  }
  EventType.values = EventType$values;
  function EventType$valueOf(name) {
    switch (name) {
      case 'POTENTIAL_INCIDENT':
        return EventType$POTENTIAL_INCIDENT_getInstance();
      case 'SENDER_POLICY_CREATED':
        return EventType$SENDER_POLICY_CREATED_getInstance();
      case 'USER_REPORTED':
        return EventType$USER_REPORTED_getInstance();
      case 'POTENTIAL_INCIDENT_EMAILS_DETECTED_COUNT':
        return EventType$POTENTIAL_INCIDENT_EMAILS_DETECTED_COUNT_getInstance();
      case 'POTENTIAL_INCIDENT_IS_EXTERNAL':
        return EventType$POTENTIAL_INCIDENT_IS_EXTERNAL_getInstance();
      case 'POTENTIAL_INCIDENT_IS_INTERNAL':
        return EventType$POTENTIAL_INCIDENT_IS_INTERNAL_getInstance();
      case 'POTENTIAL_INCIDENT_IS_TYPE_POST_DELIVERY':
        return EventType$POTENTIAL_INCIDENT_IS_TYPE_POST_DELIVERY_getInstance();
      case 'POTENTIAL_INCIDENT_IS_TYPE_RELATED':
        return EventType$POTENTIAL_INCIDENT_IS_TYPE_RELATED_getInstance();
      case 'POTENTIAL_INCIDENT_MAILBOXES_AFFECTED_COUNT':
        return EventType$POTENTIAL_INCIDENT_MAILBOXES_AFFECTED_COUNT_getInstance();
      case 'POTENTIAL_INCIDENT_SENDER_COUNTRY':
        return EventType$POTENTIAL_INCIDENT_SENDER_COUNTRY_getInstance();
      case 'POTENTIAL_INCIDENT_SENDER_EMAIL':
        return EventType$POTENTIAL_INCIDENT_SENDER_EMAIL_getInstance();
      case 'POTENTIAL_INCIDENT_SUBJECT':
        return EventType$POTENTIAL_INCIDENT_SUBJECT_getInstance();
      case 'SENDER_POLICY_BLOCK':
        return EventType$SENDER_POLICY_BLOCK_getInstance();
      case 'SENDER_POLICY_QUARANTINE':
        return EventType$SENDER_POLICY_QUARANTINE_getInstance();
      case 'SENDER_POLICY_CREATED_BY':
        return EventType$SENDER_POLICY_CREATED_BY_getInstance();
      case 'SENDER_POLICY_EMAILS_DETECTED_COUNT':
        return EventType$SENDER_POLICY_EMAILS_DETECTED_COUNT_getInstance();
      case 'SENDER_POLICY_MAILBOXES_AFFECTED_COUNT':
        return EventType$SENDER_POLICY_MAILBOXES_AFFECTED_COUNT_getInstance();
      case 'SENDER_POLICY_SENDER_COUNTRY':
        return EventType$SENDER_POLICY_SENDER_COUNTRY_getInstance();
      case 'USER_REPORTED_IS_EXTERNAL':
        return EventType$USER_REPORTED_IS_EXTERNAL_getInstance();
      case 'USER_REPORTED_IS_INTERNAL':
        return EventType$USER_REPORTED_IS_INTERNAL_getInstance();
      case 'USER_REPORTED_MATCHED_EMAIL_COUNT':
        return EventType$USER_REPORTED_MATCHED_EMAIL_COUNT_getInstance();
      case 'USER_REPORTED_REPORTED_BY':
        return EventType$USER_REPORTED_REPORTED_BY_getInstance();
      case 'USER_REPORTED_REPORTED_EMAIL_COUNT':
        return EventType$USER_REPORTED_REPORTED_EMAIL_COUNT_getInstance();
      case 'USER_REPORTED_SENDER_COUNTRY':
        return EventType$USER_REPORTED_SENDER_COUNTRY_getInstance();
      case 'USER_REPORTED_SENDER_EMAIL':
        return EventType$USER_REPORTED_SENDER_EMAIL_getInstance();
      case 'USER_REPORTED_SUBJECT':
        return EventType$USER_REPORTED_SUBJECT_getInstance();
      case 'CREATE_INCIDENT':
        return EventType$CREATE_INCIDENT_getInstance();
      case 'EMAIL_NOTIFICATION':
        return EventType$EMAIL_NOTIFICATION_getInstance();
      case 'SLACK_NOTIFICATION':
        return EventType$SLACK_NOTIFICATION_getInstance();
      case 'MSTEAMS_NOTIFICATION':
        return EventType$MSTEAMS_NOTIFICATION_getInstance();
      default:
        throwISE('No enum constant com.barracuda.fir.workflow.EventType.' + name);
    }
  }
  EventType.valueOf_61zpoe$ = EventType$valueOf;
  var senderPolicyPrefix;
  var userReportedPrefix;
  var potentialIncidentPrefix;
  var countSuffix;
  var countrySuffix;
  var noInputSuffix;
  function getTriggers() {
    return setOf([EventType$POTENTIAL_INCIDENT_getInstance(), EventType$USER_REPORTED_getInstance(), EventType$SENDER_POLICY_CREATED_getInstance()]);
  }
  function getConditions() {
    return setOf([EventType$POTENTIAL_INCIDENT_SUBJECT_getInstance(), EventType$POTENTIAL_INCIDENT_IS_EXTERNAL_getInstance(), EventType$POTENTIAL_INCIDENT_IS_INTERNAL_getInstance(), EventType$POTENTIAL_INCIDENT_EMAILS_DETECTED_COUNT_getInstance(), EventType$POTENTIAL_INCIDENT_MAILBOXES_AFFECTED_COUNT_getInstance(), EventType$POTENTIAL_INCIDENT_IS_TYPE_POST_DELIVERY_getInstance(), EventType$POTENTIAL_INCIDENT_IS_TYPE_RELATED_getInstance(), EventType$POTENTIAL_INCIDENT_SENDER_COUNTRY_getInstance(), EventType$POTENTIAL_INCIDENT_SENDER_EMAIL_getInstance(), EventType$SENDER_POLICY_BLOCK_getInstance(), EventType$SENDER_POLICY_CREATED_BY_getInstance(), EventType$SENDER_POLICY_EMAILS_DETECTED_COUNT_getInstance(), EventType$SENDER_POLICY_MAILBOXES_AFFECTED_COUNT_getInstance(), EventType$SENDER_POLICY_QUARANTINE_getInstance(), EventType$SENDER_POLICY_SENDER_COUNTRY_getInstance(), EventType$USER_REPORTED_SUBJECT_getInstance(), EventType$USER_REPORTED_IS_EXTERNAL_getInstance(), EventType$USER_REPORTED_IS_INTERNAL_getInstance(), EventType$USER_REPORTED_MATCHED_EMAIL_COUNT_getInstance(), EventType$USER_REPORTED_REPORTED_EMAIL_COUNT_getInstance(), EventType$USER_REPORTED_REPORTED_BY_getInstance(), EventType$USER_REPORTED_SENDER_COUNTRY_getInstance(), EventType$USER_REPORTED_SENDER_EMAIL_getInstance()]);
  }
  function getActions() {
    return setOf([EventType$CREATE_INCIDENT_getInstance(), EventType$EMAIL_NOTIFICATION_getInstance(), EventType$SLACK_NOTIFICATION_getInstance(), EventType$MSTEAMS_NOTIFICATION_getInstance()]);
  }
  function getAllOfType(nodeType) {
    var tmp$;
    switch (nodeType.name) {
      case 'TRIGGER':
        tmp$ = getTriggers();
        break;
      case 'CONDITION':
        tmp$ = getConditions();
        break;
      case 'ACTION':
        tmp$ = getActions();
        break;
      default:
        tmp$ = Kotlin.noWhenBranchMatched();
        break;
    }
    return tmp$;
  }
  function getValidChildren(node) {
    var tmp$;
    if (node.type === NodeType$ACTION_getInstance()) {
      return emptySet();
    }
    var validChildren = toMutableSet(getActions());
    var $receiver = getTriggers();
    var firstOrNull$result;
    firstOrNull$break: do {
      var tmp$_0;
      tmp$_0 = $receiver.iterator();
      while (tmp$_0.hasNext()) {
        var element = tmp$_0.next();
        if (startsWith(node.eventType.value, element.value)) {
          firstOrNull$result = element;
          break firstOrNull$break;
        }
      }
      firstOrNull$result = null;
    }
     while (false);
    if ((tmp$ = firstOrNull$result) != null) {
      var $receiver_0 = getConditions();
      var destination = ArrayList_init();
      var tmp$_1;
      tmp$_1 = $receiver_0.iterator();
      while (tmp$_1.hasNext()) {
        var element_0 = tmp$_1.next();
        if (startsWith(element_0.value, tmp$.value))
          destination.add_11rb$(element_0);
      }
      validChildren.addAll_brywnq$(destination);
    }
    return validChildren;
  }
  function Node(type, eventType, config, uuid, targets) {
    if (config === void 0)
      config = null;
    if (uuid === void 0)
      uuid = UUID4_getInstance().create();
    if (targets === void 0)
      targets = null;
    this.type = type;
    this.eventType = eventType;
    this.config = config;
    this.uuid = uuid;
    this.targets_us4b9a$_0 = targets;
    this.children_0 = LinkedHashSet_init();
  }
  Object.defineProperty(Node.prototype, 'targets', {
    configurable: true,
    get: function () {
      var tmp$;
      var tmp$_0;
      if ((tmp$ = this.targets_us4b9a$_0) != null)
        tmp$_0 = tmp$;
      else {
        var $receiver = this.children_0;
        var destination = ArrayList_init_0(collectionSizeOrDefault($receiver, 10));
        var tmp$_1;
        tmp$_1 = $receiver.iterator();
        while (tmp$_1.hasNext()) {
          var item = tmp$_1.next();
          destination.add_11rb$(item.uuid);
        }
        tmp$_0 = toSet(destination);
      }
      return tmp$_0;
    }
  });
  Node.prototype.getChildren_8be2vx$ = function () {
    return this.children_0;
  };
  Node.prototype.addChild_8q0bfv$ = function (childNode) {
    return this.children_0.add_11rb$(childNode);
  };
  Node.prototype.removeChild_8q0bfv$ = function (childNode) {
    return this.children_0.remove_11rb$(childNode);
  };
  Node.prototype.equals = function (other) {
    var tmp$;
    if (Kotlin.isType(other, Node))
      tmp$ = equals(this.uuid, other.uuid);
    else
      tmp$ = false;
    return tmp$;
  };
  Node.prototype.hashCode = function () {
    return hashCode(this.uuid);
  };
  Node.prototype.toString = function () {
    return 'Node(type=' + this.type + ', eventType=' + this.eventType + ", config='" + toString(this.config) + "', uuid='" + this.uuid + "', targets=" + toString(this.targets) + ')';
  };
  Node.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Node',
    interfaces: []
  };
  function NodeConfig(conditionOperator, conditionValue) {
    this.conditionOperator = conditionOperator;
    this.conditionValue = conditionValue;
  }
  NodeConfig.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'NodeConfig',
    interfaces: []
  };
  NodeConfig.prototype.component1 = function () {
    return this.conditionOperator;
  };
  NodeConfig.prototype.component2 = function () {
    return this.conditionValue;
  };
  NodeConfig.prototype.copy_rkkr90$ = function (conditionOperator, conditionValue) {
    return new NodeConfig(conditionOperator === void 0 ? this.conditionOperator : conditionOperator, conditionValue === void 0 ? this.conditionValue : conditionValue);
  };
  NodeConfig.prototype.toString = function () {
    return 'NodeConfig(conditionOperator=' + Kotlin.toString(this.conditionOperator) + (', conditionValue=' + Kotlin.toString(this.conditionValue)) + ')';
  };
  NodeConfig.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.conditionOperator) | 0;
    result = result * 31 + Kotlin.hashCode(this.conditionValue) | 0;
    return result;
  };
  NodeConfig.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.conditionOperator, other.conditionOperator) && Kotlin.equals(this.conditionValue, other.conditionValue)))));
  };
  function NodeException(message) {
    RuntimeException_init(message, this);
    this.name = 'NodeException';
  }
  NodeException.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'NodeException',
    interfaces: [RuntimeException]
  };
  function InvalidTargetException(message) {
    NodeException.call(this, message);
    this.name = 'InvalidTargetException';
  }
  InvalidTargetException.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'InvalidTargetException',
    interfaces: [NodeException]
  };
  function InvalidEventException(message) {
    NodeException.call(this, message);
    this.name = 'InvalidEventException';
  }
  InvalidEventException.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'InvalidEventException',
    interfaces: [NodeException]
  };
  function InvalidRootException(message) {
    NodeException.call(this, message);
    this.name = 'InvalidRootException';
  }
  InvalidRootException.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'InvalidRootException',
    interfaces: [NodeException]
  };
  function NodeTree(root) {
    if (root === void 0)
      root = null;
    this.root_0 = root;
  }
  NodeTree.prototype.setRoot_7fyr3c$ = function (root) {
    try {
      this.validate_0(root);
      this.root_0 = root;
      return true;
    } catch (e) {
      if (Kotlin.isType(e, NodeException)) {
        return false;
      } else
        throw e;
    }
  };
  NodeTree.prototype.addNode_j68yu4$ = function (parent, child) {
    var tmp$;
    if (parent.addChild_8q0bfv$(child))
      try {
        this.validate_0(this.root_0);
        tmp$ = true;
      } catch (e) {
        if (Kotlin.isType(e, NodeException)) {
          parent.removeChild_8q0bfv$(child);
          tmp$ = false;
        } else
          throw e;
      }
     else
      tmp$ = false;
    return tmp$;
  };
  NodeTree.prototype.removeNode_j68yu4$ = function (parent, child) {
    return parent.removeChild_8q0bfv$(child);
  };
  NodeTree.prototype.getNodeSet = function () {
    return this.getNodeSet_0(this.root_0);
  };
  NodeTree.prototype.validate = function () {
    return this.validate_0(this.root_0);
  };
  NodeTree.prototype.getNodeSet_0 = function (node, nodes) {
    if (nodes === void 0) {
      nodes = LinkedHashSet_init();
    }
    var tmp$;
    var thisNode = nodes.isEmpty() || node == null ? this.validate_0(node) : node;
    nodes.add_11rb$(thisNode);
    tmp$ = thisNode.getChildren_8be2vx$().iterator();
    while (tmp$.hasNext()) {
      var child = tmp$.next();
      this.getNodeSet_0(child, nodes);
    }
    return nodes;
  };
  NodeTree.prototype.validate_0 = function (rootNode, ancestors) {
    if (ancestors === void 0)
      ancestors = emptySet();
    var tmp$;
    if (rootNode == null || (rootNode.type !== NodeType$TRIGGER_getInstance() && ancestors.isEmpty())) {
      throw new InvalidRootException('Root node must be of type ' + NodeType$TRIGGER_getInstance());
    }
    if (!getAllOfType(rootNode.type).contains_11rb$(rootNode.eventType)) {
      throw new InvalidEventException(rootNode.eventType.toString() + ' is not an event of ' + rootNode.type);
    }
    if (ancestors.contains_11rb$(rootNode)) {
      throw new InvalidTargetException('Loop detected. Node cannot be an ancestor of itself');
    }
    var newAncestors = setOf(copyToArray(ancestors).concat([rootNode]));
    tmp$ = rootNode.getChildren_8be2vx$().iterator();
    while (tmp$.hasNext()) {
      var child = tmp$.next();
      if (!getValidChildren(rootNode).contains_11rb$(child.eventType)) {
        throw new InvalidTargetException(child.eventType.toString() + ' cannot be a child of ' + rootNode.eventType);
      }
      this.validate_0(child, newAncestors);
    }
    return rootNode;
  };
  NodeTree.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'NodeTree',
    interfaces: []
  };
  function NodeType(name, ordinal, value) {
    Enum.call(this);
    this.value = value;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function NodeType_initFields() {
    NodeType_initFields = function () {
    };
    NodeType$TRIGGER_instance = new NodeType('TRIGGER', 0, 'trigger');
    NodeType$CONDITION_instance = new NodeType('CONDITION', 1, 'condition');
    NodeType$ACTION_instance = new NodeType('ACTION', 2, 'action');
    NodeType$Companion_getInstance();
  }
  var NodeType$TRIGGER_instance;
  function NodeType$TRIGGER_getInstance() {
    NodeType_initFields();
    return NodeType$TRIGGER_instance;
  }
  var NodeType$CONDITION_instance;
  function NodeType$CONDITION_getInstance() {
    NodeType_initFields();
    return NodeType$CONDITION_instance;
  }
  var NodeType$ACTION_instance;
  function NodeType$ACTION_getInstance() {
    NodeType_initFields();
    return NodeType$ACTION_instance;
  }
  function NodeType$Companion() {
    NodeType$Companion_instance = this;
  }
  NodeType$Companion.prototype.from_61zpoe$ = function (value) {
    var $receiver = NodeType$values();
    var first$result;
    first$break: do {
      var tmp$;
      for (tmp$ = 0; tmp$ !== $receiver.length; ++tmp$) {
        var element = $receiver[tmp$];
        if (equals(element.value, value)) {
          first$result = element;
          break first$break;
        }
      }
      throw new NoSuchElementException_init('Array contains no element matching the predicate.');
    }
     while (false);
    return first$result;
  };
  NodeType$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var NodeType$Companion_instance = null;
  function NodeType$Companion_getInstance() {
    NodeType_initFields();
    if (NodeType$Companion_instance === null) {
      new NodeType$Companion();
    }
    return NodeType$Companion_instance;
  }
  NodeType.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'NodeType',
    interfaces: [Enum]
  };
  function NodeType$values() {
    return [NodeType$TRIGGER_getInstance(), NodeType$CONDITION_getInstance(), NodeType$ACTION_getInstance()];
  }
  NodeType.values = NodeType$values;
  function NodeType$valueOf(name) {
    switch (name) {
      case 'TRIGGER':
        return NodeType$TRIGGER_getInstance();
      case 'CONDITION':
        return NodeType$CONDITION_getInstance();
      case 'ACTION':
        return NodeType$ACTION_getInstance();
      default:
        throwISE('No enum constant com.barracuda.fir.workflow.NodeType.' + name);
    }
  }
  NodeType.valueOf_61zpoe$ = NodeType$valueOf;
  function WorkflowNodeConfig(conditionOperator, conditionValue) {
    if (conditionOperator === void 0)
      conditionOperator = null;
    if (conditionValue === void 0)
      conditionValue = null;
    this.config = new NodeConfig(conditionOperator, conditionValue);
  }
  WorkflowNodeConfig.prototype.getConditionOperator = function () {
    return this.config.conditionOperator;
  };
  WorkflowNodeConfig.prototype.getConditionValue = function () {
    return this.config.conditionValue;
  };
  WorkflowNodeConfig.prototype.equals = function (other) {
    var tmp$, tmp$_0;
    if (this === other)
      return true;
    if (other == null || !equals(get_js(Kotlin.getKClassFromExpression(this)), get_js(Kotlin.getKClassFromExpression(other))))
      return false;
    Kotlin.isType(tmp$ = other, WorkflowNodeConfig) ? tmp$ : throwCCE();
    if (!((tmp$_0 = this.config) != null ? tmp$_0.equals(other.config) : null))
      return false;
    return true;
  };
  WorkflowNodeConfig.prototype.hashCode = function () {
    return this.config.hashCode();
  };
  WorkflowNodeConfig.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'WorkflowNodeConfig',
    interfaces: []
  };
  function WorkflowNode(type, eventType, config, uuid) {
    if (config === void 0)
      config = null;
    if (uuid === void 0)
      uuid = null;
    this.node = uuid != null ? new Node(NodeType$Companion_getInstance().from_61zpoe$(type), EventType$Companion_getInstance().from_61zpoe$(eventType), config != null ? config.config : null, uuid) : new Node(NodeType$Companion_getInstance().from_61zpoe$(type), EventType$Companion_getInstance().from_61zpoe$(eventType), config != null ? config.config : null);
  }
  WorkflowNode.prototype.getType = function () {
    return this.node.type.value;
  };
  WorkflowNode.prototype.getEventType = function () {
    return this.node.eventType.value;
  };
  WorkflowNode.prototype.getConfig = function () {
    var tmp$;
    return (tmp$ = this.node.config) != null ? this.wrapNodeConfig_0(tmp$) : null;
  };
  WorkflowNode.prototype.getUUID = function () {
    return this.node.uuid;
  };
  WorkflowNode.prototype.getTargets = function () {
    return copyToArray(ensureNotNull(this.node.targets));
  };
  WorkflowNode.prototype.wrapNodeConfig_0 = function (nodeConfig) {
    var workflowNodeConfig = new WorkflowNodeConfig();
    workflowNodeConfig.config = nodeConfig;
    return workflowNodeConfig;
  };
  WorkflowNode.prototype.equals = function (other) {
    var tmp$, tmp$_0;
    if (Kotlin.isType(other, WorkflowNode))
      tmp$_0 = (tmp$ = this.node) != null ? tmp$.equals(other.node) : null;
    else
      tmp$_0 = false;
    return tmp$_0;
  };
  WorkflowNode.prototype.hashCode = function () {
    return this.node.hashCode();
  };
  WorkflowNode.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'WorkflowNode',
    interfaces: []
  };
  function Workflow() {
    this.uuid = UUID4_getInstance().create();
    this.name = '';
    this.description = '';
    this.diagram = null;
    this.editor = '';
    this.nodeTree_0 = new NodeTree();
  }
  Workflow.prototype.setRoot = function (root) {
    this.nodeTree_0.setRoot_7fyr3c$(root.node);
  };
  Workflow.prototype.addLink = function (parent, child) {
    return this.nodeTree_0.addNode_j68yu4$(parent.node, child.node);
  };
  Workflow.prototype.removeLink = function (parent, child) {
    return this.nodeTree_0.removeNode_j68yu4$(parent.node, child.node);
  };
  Workflow.prototype.getNodes = function () {
    var $receiver = this.nodeTree_0.getNodeSet();
    var destination = ArrayList_init_0(collectionSizeOrDefault($receiver, 10));
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var item = tmp$.next();
      destination.add_11rb$(this.wrapNode_0(item));
    }
    return copyToArray(destination);
  };
  Workflow.prototype.validate = function () {
    this.nodeTree_0.validate();
  };
  function Workflow$load$lambda$lambda(nodeConfig) {
    var tmp$, tmp$_0;
    return new WorkflowNodeConfig(typeof (tmp$ = nodeConfig.conditionOperator) === 'string' ? tmp$ : null, typeof (tmp$_0 = nodeConfig.conditionValue) === 'string' ? tmp$_0 : null);
  }
  Workflow.prototype.load = function (workflow) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6, tmp$_7, tmp$_8, tmp$_9, tmp$_10, tmp$_11;
    this.uuid = typeof (tmp$ = workflow.uuid) === 'string' ? tmp$ : null;
    this.name = typeof (tmp$_0 = workflow.name) === 'string' ? tmp$_0 : throwCCE();
    this.description = typeof (tmp$_1 = workflow.description) === 'string' ? tmp$_1 : throwCCE();
    this.diagram = typeof (tmp$_2 = workflow.diagram) === 'string' ? tmp$_2 : null;
    this.editor = typeof (tmp$_3 = workflow.editor) === 'string' ? tmp$_3 : null;
    var nodeMap = LinkedHashMap_init();
    var nodes = Kotlin.isArray(tmp$_4 = workflow.nodes) ? tmp$_4 : throwCCE();
    var tmp$_12;
    for (tmp$_12 = 0; tmp$_12 !== nodes.length; ++tmp$_12) {
      var element = nodes[tmp$_12];
      var tmp$_13, tmp$_14, tmp$_15, tmp$_16, tmp$_17;
      var workflowNodeConfig = (tmp$_13 = element.config) != null ? tmp$_13.let(Workflow$load$lambda$lambda) : null;
      var workflowNode = new WorkflowNode(typeof (tmp$_14 = element.type) === 'string' ? tmp$_14 : throwCCE(), typeof (tmp$_15 = element.eventType) === 'string' ? tmp$_15 : throwCCE(), Kotlin.isType(tmp$_16 = workflowNodeConfig, WorkflowNodeConfig) ? tmp$_16 : null, typeof (tmp$_17 = element.uuid) === 'string' ? tmp$_17 : null);
      if (equals(workflowNode.getType(), NodeConstants_getInstance().TRIGGER)) {
        this.setRoot(workflowNode);
      }
      var key = workflowNode.getUUID();
      nodeMap.put_xwzc9p$(key, workflowNode);
    }
    for (tmp$_5 = 0; tmp$_5 !== nodes.length; ++tmp$_5) {
      var node = nodes[tmp$_5];
      tmp$_7 = nodeMap.get_11rb$(typeof (tmp$_6 = node.uuid) === 'string' ? tmp$_6 : throwCCE());
      if (tmp$_7 == null) {
        continue;
      }
      var parent = tmp$_7;
      tmp$_9 = Kotlin.isArray(tmp$_8 = node.targets) ? tmp$_8 : throwCCE();
      for (tmp$_10 = 0; tmp$_10 !== tmp$_9.length; ++tmp$_10) {
        var targetUUID = tmp$_9[tmp$_10];
        tmp$_11 = nodeMap.get_11rb$(targetUUID);
        if (tmp$_11 == null) {
          continue;
        }
        var target = tmp$_11;
        this.addLink(parent, target);
      }
    }
    return this;
  };
  function Workflow$getSerializable$ObjectLiteral() {
  }
  Workflow$getSerializable$ObjectLiteral.$metadata$ = {
    kind: Kind_CLASS,
    interfaces: []
  };
  Workflow.prototype.getSerializable = function () {
    var workflow = new Workflow$getSerializable$ObjectLiteral();
    workflow.uuid = this.uuid;
    workflow.name = this.name;
    workflow.description = this.description;
    workflow.diagram = this.diagram;
    workflow.editor = this.editor;
    var $receiver = this.getNodes();
    var destination = ArrayList_init_0($receiver.length);
    var tmp$;
    for (tmp$ = 0; tmp$ !== $receiver.length; ++tmp$) {
      var item = $receiver[tmp$];
      destination.add_11rb$(this.serializableNode_0(item));
    }
    workflow.nodes = copyToArray(destination);
    return workflow;
  };
  function Workflow$serializableNode$ObjectLiteral() {
  }
  Workflow$serializableNode$ObjectLiteral.$metadata$ = {
    kind: Kind_CLASS,
    interfaces: []
  };
  Workflow.prototype.serializableNode_0 = function (workflowNode) {
    var tmp$;
    var node = new Workflow$serializableNode$ObjectLiteral();
    node.uuid = workflowNode.getUUID();
    node.type = workflowNode.getType();
    node.eventType = workflowNode.getEventType();
    node.targets = workflowNode.getTargets();
    node.config = (tmp$ = workflowNode.getConfig()) != null ? this.serializableNodeConfig_0(tmp$) : null;
    return node;
  };
  function Workflow$serializableNodeConfig$ObjectLiteral() {
  }
  Workflow$serializableNodeConfig$ObjectLiteral.$metadata$ = {
    kind: Kind_CLASS,
    interfaces: []
  };
  Workflow.prototype.serializableNodeConfig_0 = function (workflowNodeConfig) {
    var nodeConfig = new Workflow$serializableNodeConfig$ObjectLiteral();
    nodeConfig.conditionOperator = workflowNodeConfig.getConditionOperator();
    nodeConfig.conditionValue = workflowNodeConfig.getConditionValue();
    return nodeConfig;
  };
  Workflow.prototype.wrapNode_0 = function (node) {
    var workflowNode = new WorkflowNode(NodeConstants_getInstance().ACTION, EventConstants_getInstance().SENDER_POLICY_CREATED);
    workflowNode.node = node;
    return workflowNode;
  };
  Workflow.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Workflow',
    interfaces: []
  };
  function NodeConstants() {
    NodeConstants_instance = this;
    this.TRIGGER = NodeType$TRIGGER_getInstance().value;
    this.CONDITION = NodeType$CONDITION_getInstance().value;
    this.ACTION = NodeType$ACTION_getInstance().value;
  }
  NodeConstants.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'NodeConstants',
    interfaces: []
  };
  var NodeConstants_instance = null;
  function NodeConstants_getInstance() {
    if (NodeConstants_instance === null) {
      new NodeConstants();
    }
    return NodeConstants_instance;
  }
  function EventConstants() {
    EventConstants_instance = this;
    this.POTENTIAL_INCIDENT = EventType$POTENTIAL_INCIDENT_getInstance().value;
    this.SENDER_POLICY_CREATED = EventType$SENDER_POLICY_CREATED_getInstance().value;
    this.USER_REPORTED = EventType$USER_REPORTED_getInstance().value;
    this.POTENTIAL_INCIDENT_EMAILS_DETECTED_COUNT = EventType$POTENTIAL_INCIDENT_EMAILS_DETECTED_COUNT_getInstance().value;
    this.POTENTIAL_INCIDENT_IS_EXTERNAL = EventType$POTENTIAL_INCIDENT_IS_EXTERNAL_getInstance().value;
    this.POTENTIAL_INCIDENT_IS_INTERNAL = EventType$POTENTIAL_INCIDENT_IS_INTERNAL_getInstance().value;
    this.POTENTIAL_INCIDENT_IS_TYPE_POST_DELIVERY = EventType$POTENTIAL_INCIDENT_IS_TYPE_POST_DELIVERY_getInstance().value;
    this.POTENTIAL_INCIDENT_IS_TYPE_RELATED = EventType$POTENTIAL_INCIDENT_IS_TYPE_RELATED_getInstance().value;
    this.POTENTIAL_INCIDENT_MAILBOXES_AFFECTED_COUNT = EventType$POTENTIAL_INCIDENT_MAILBOXES_AFFECTED_COUNT_getInstance().value;
    this.POTENTIAL_INCIDENT_SENDER_COUNTRY = EventType$POTENTIAL_INCIDENT_SENDER_COUNTRY_getInstance().value;
    this.POTENTIAL_INCIDENT_SENDER_EMAIL = EventType$POTENTIAL_INCIDENT_SENDER_EMAIL_getInstance().value;
    this.POTENTIAL_INCIDENT_SUBJECT = EventType$POTENTIAL_INCIDENT_SUBJECT_getInstance().value;
    this.SENDER_POLICY_BLOCK = EventType$SENDER_POLICY_BLOCK_getInstance().value;
    this.SENDER_POLICY_CREATED_BY = EventType$SENDER_POLICY_CREATED_BY_getInstance().value;
    this.SENDER_POLICY_EMAILS_DETECTED_COUNT = EventType$SENDER_POLICY_EMAILS_DETECTED_COUNT_getInstance().value;
    this.SENDER_POLICY_MAILBOXES_AFFECTED_COUNT = EventType$SENDER_POLICY_MAILBOXES_AFFECTED_COUNT_getInstance().value;
    this.SENDER_POLICY_QUARANTINE = EventType$SENDER_POLICY_QUARANTINE_getInstance().value;
    this.SENDER_POLICY_SENDER_COUNTRY = EventType$SENDER_POLICY_SENDER_COUNTRY_getInstance().value;
    this.USER_REPORTED_IS_EXTERNAL = EventType$USER_REPORTED_IS_EXTERNAL_getInstance().value;
    this.USER_REPORTED_IS_INTERNAL = EventType$USER_REPORTED_IS_INTERNAL_getInstance().value;
    this.USER_REPORTED_MATCHED_EMAIL_COUNT = EventType$USER_REPORTED_MATCHED_EMAIL_COUNT_getInstance().value;
    this.USER_REPORTED_REPORTED_BY = EventType$USER_REPORTED_REPORTED_BY_getInstance().value;
    this.USER_REPORTED_REPORTED_EMAIL_COUNT = EventType$USER_REPORTED_REPORTED_EMAIL_COUNT_getInstance().value;
    this.USER_REPORTED_SENDER_COUNTRY = EventType$USER_REPORTED_SENDER_COUNTRY_getInstance().value;
    this.USER_REPORTED_SENDER_EMAIL = EventType$USER_REPORTED_SENDER_EMAIL_getInstance().value;
    this.USER_REPORTED_SUBJECT = EventType$USER_REPORTED_SUBJECT_getInstance().value;
    this.CREATE_INCIDENT = EventType$CREATE_INCIDENT_getInstance().value;
    this.EMAIL_NOTIFICATION = EventType$EMAIL_NOTIFICATION_getInstance().value;
    this.SLACK_NOTIFICATION = EventType$SLACK_NOTIFICATION_getInstance().value;
    this.MSTEAMS_NOTIFICATION = EventType$MSTEAMS_NOTIFICATION_getInstance().value;
    var $receiver = getTriggers();
    var destination = ArrayList_init_0(collectionSizeOrDefault($receiver, 10));
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var item = tmp$.next();
      destination.add_11rb$(item.value);
    }
    this.TRIGGERS = copyToArray(destination);
    var $receiver_0 = getConditions();
    var destination_0 = ArrayList_init_0(collectionSizeOrDefault($receiver_0, 10));
    var tmp$_0;
    tmp$_0 = $receiver_0.iterator();
    while (tmp$_0.hasNext()) {
      var item_0 = tmp$_0.next();
      destination_0.add_11rb$(item_0.value);
    }
    this.CONDITIONS = copyToArray(destination_0);
    var $receiver_1 = getActions();
    var destination_1 = ArrayList_init_0(collectionSizeOrDefault($receiver_1, 10));
    var tmp$_1;
    tmp$_1 = $receiver_1.iterator();
    while (tmp$_1.hasNext()) {
      var item_1 = tmp$_1.next();
      destination_1.add_11rb$(item_1.value);
    }
    this.ACTIONS = copyToArray(destination_1);
  }
  EventConstants.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'EventConstants',
    interfaces: []
  };
  var EventConstants_instance = null;
  function EventConstants_getInstance() {
    if (EventConstants_instance === null) {
      new EventConstants();
    }
    return EventConstants_instance;
  }
  function UUID4() {
    UUID4_instance = this;
  }
  UUID4.prototype.create = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
      var random = Math.random() * 16 | 0;
      var result = char == 'x' ? random : random & 3 | 8;
      return result.toString(16);
    });
  };
  UUID4.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'UUID4',
    interfaces: []
  };
  var UUID4_instance = null;
  function UUID4_getInstance() {
    if (UUID4_instance === null) {
      new UUID4();
    }
    return UUID4_instance;
  }
  Object.defineProperty(EventType, 'POTENTIAL_INCIDENT', {
    get: EventType$POTENTIAL_INCIDENT_getInstance
  });
  Object.defineProperty(EventType, 'SENDER_POLICY_CREATED', {
    get: EventType$SENDER_POLICY_CREATED_getInstance
  });
  Object.defineProperty(EventType, 'USER_REPORTED', {
    get: EventType$USER_REPORTED_getInstance
  });
  Object.defineProperty(EventType, 'POTENTIAL_INCIDENT_EMAILS_DETECTED_COUNT', {
    get: EventType$POTENTIAL_INCIDENT_EMAILS_DETECTED_COUNT_getInstance
  });
  Object.defineProperty(EventType, 'POTENTIAL_INCIDENT_IS_EXTERNAL', {
    get: EventType$POTENTIAL_INCIDENT_IS_EXTERNAL_getInstance
  });
  Object.defineProperty(EventType, 'POTENTIAL_INCIDENT_IS_INTERNAL', {
    get: EventType$POTENTIAL_INCIDENT_IS_INTERNAL_getInstance
  });
  Object.defineProperty(EventType, 'POTENTIAL_INCIDENT_IS_TYPE_POST_DELIVERY', {
    get: EventType$POTENTIAL_INCIDENT_IS_TYPE_POST_DELIVERY_getInstance
  });
  Object.defineProperty(EventType, 'POTENTIAL_INCIDENT_IS_TYPE_RELATED', {
    get: EventType$POTENTIAL_INCIDENT_IS_TYPE_RELATED_getInstance
  });
  Object.defineProperty(EventType, 'POTENTIAL_INCIDENT_MAILBOXES_AFFECTED_COUNT', {
    get: EventType$POTENTIAL_INCIDENT_MAILBOXES_AFFECTED_COUNT_getInstance
  });
  Object.defineProperty(EventType, 'POTENTIAL_INCIDENT_SENDER_COUNTRY', {
    get: EventType$POTENTIAL_INCIDENT_SENDER_COUNTRY_getInstance
  });
  Object.defineProperty(EventType, 'POTENTIAL_INCIDENT_SENDER_EMAIL', {
    get: EventType$POTENTIAL_INCIDENT_SENDER_EMAIL_getInstance
  });
  Object.defineProperty(EventType, 'POTENTIAL_INCIDENT_SUBJECT', {
    get: EventType$POTENTIAL_INCIDENT_SUBJECT_getInstance
  });
  Object.defineProperty(EventType, 'SENDER_POLICY_BLOCK', {
    get: EventType$SENDER_POLICY_BLOCK_getInstance
  });
  Object.defineProperty(EventType, 'SENDER_POLICY_QUARANTINE', {
    get: EventType$SENDER_POLICY_QUARANTINE_getInstance
  });
  Object.defineProperty(EventType, 'SENDER_POLICY_CREATED_BY', {
    get: EventType$SENDER_POLICY_CREATED_BY_getInstance
  });
  Object.defineProperty(EventType, 'SENDER_POLICY_EMAILS_DETECTED_COUNT', {
    get: EventType$SENDER_POLICY_EMAILS_DETECTED_COUNT_getInstance
  });
  Object.defineProperty(EventType, 'SENDER_POLICY_MAILBOXES_AFFECTED_COUNT', {
    get: EventType$SENDER_POLICY_MAILBOXES_AFFECTED_COUNT_getInstance
  });
  Object.defineProperty(EventType, 'SENDER_POLICY_SENDER_COUNTRY', {
    get: EventType$SENDER_POLICY_SENDER_COUNTRY_getInstance
  });
  Object.defineProperty(EventType, 'USER_REPORTED_IS_EXTERNAL', {
    get: EventType$USER_REPORTED_IS_EXTERNAL_getInstance
  });
  Object.defineProperty(EventType, 'USER_REPORTED_IS_INTERNAL', {
    get: EventType$USER_REPORTED_IS_INTERNAL_getInstance
  });
  Object.defineProperty(EventType, 'USER_REPORTED_MATCHED_EMAIL_COUNT', {
    get: EventType$USER_REPORTED_MATCHED_EMAIL_COUNT_getInstance
  });
  Object.defineProperty(EventType, 'USER_REPORTED_REPORTED_BY', {
    get: EventType$USER_REPORTED_REPORTED_BY_getInstance
  });
  Object.defineProperty(EventType, 'USER_REPORTED_REPORTED_EMAIL_COUNT', {
    get: EventType$USER_REPORTED_REPORTED_EMAIL_COUNT_getInstance
  });
  Object.defineProperty(EventType, 'USER_REPORTED_SENDER_COUNTRY', {
    get: EventType$USER_REPORTED_SENDER_COUNTRY_getInstance
  });
  Object.defineProperty(EventType, 'USER_REPORTED_SENDER_EMAIL', {
    get: EventType$USER_REPORTED_SENDER_EMAIL_getInstance
  });
  Object.defineProperty(EventType, 'USER_REPORTED_SUBJECT', {
    get: EventType$USER_REPORTED_SUBJECT_getInstance
  });
  Object.defineProperty(EventType, 'CREATE_INCIDENT', {
    get: EventType$CREATE_INCIDENT_getInstance
  });
  Object.defineProperty(EventType, 'EMAIL_NOTIFICATION', {
    get: EventType$EMAIL_NOTIFICATION_getInstance
  });
  Object.defineProperty(EventType, 'SLACK_NOTIFICATION', {
    get: EventType$SLACK_NOTIFICATION_getInstance
  });
  Object.defineProperty(EventType, 'MSTEAMS_NOTIFICATION', {
    get: EventType$MSTEAMS_NOTIFICATION_getInstance
  });
  Object.defineProperty(EventType, 'Companion', {
    get: EventType$Companion_getInstance
  });
  var package$com = _.com || (_.com = {});
  var package$barracuda = package$com.barracuda || (package$com.barracuda = {});
  var package$fir = package$barracuda.fir || (package$barracuda.fir = {});
  var package$workflow = package$fir.workflow || (package$fir.workflow = {});
  package$workflow.EventType = EventType;
  package$workflow.getTriggers = getTriggers;
  package$workflow.getConditions = getConditions;
  package$workflow.getActions = getActions;
  package$workflow.getAllOfType_h5rwu6$ = getAllOfType;
  package$workflow.getValidChildren_7fyr3c$ = getValidChildren;
  package$workflow.Node = Node;
  package$workflow.NodeConfig = NodeConfig;
  package$workflow.NodeException = NodeException;
  package$workflow.InvalidTargetException = InvalidTargetException;
  package$workflow.InvalidEventException = InvalidEventException;
  package$workflow.InvalidRootException = InvalidRootException;
  package$workflow.NodeTree = NodeTree;
  Object.defineProperty(NodeType, 'TRIGGER', {
    get: NodeType$TRIGGER_getInstance
  });
  Object.defineProperty(NodeType, 'CONDITION', {
    get: NodeType$CONDITION_getInstance
  });
  Object.defineProperty(NodeType, 'ACTION', {
    get: NodeType$ACTION_getInstance
  });
  Object.defineProperty(NodeType, 'Companion', {
    get: NodeType$Companion_getInstance
  });
  package$workflow.NodeType = NodeType;
  _.WorkflowNodeConfig = WorkflowNodeConfig;
  _.WorkflowNode = WorkflowNode;
  _.Workflow = Workflow;
  Object.defineProperty(_, 'NodeConstants', {
    get: NodeConstants_getInstance
  });
  Object.defineProperty(_, 'EventConstants', {
    get: EventConstants_getInstance
  });
  var package$util = package$barracuda.util || (package$barracuda.util = {});
  Object.defineProperty(package$util, 'UUID4', {
    get: UUID4_getInstance
  });
  senderPolicyPrefix = 'senderPolicy';
  userReportedPrefix = 'userReported';
  potentialIncidentPrefix = 'potentialIncident';
  countSuffix = 'Count';
  countrySuffix = 'Country';
  noInputSuffix = '_noInput';
  Kotlin.defineModule('automated-workflows-shared', _);
  return _;
}));

//# sourceMappingURL=automated-workflows-shared.js.map
